export default __webpack_public_path__ + "static/media/frog_R2_C7.d0c1d38e.png";